import styled from 'styled-components';
import { compose, color, typography, space, layout } from 'styled-system';

var Text = styled.div({ whiteSpace: "pre-line" }, compose(color, typography, space, layout));

export { Text };
//# sourceMappingURL=Text.js.map
